import { useBreakpointValue, useTheme } from '@chakra-ui/react';
import { useLayoutEffect, useState } from 'react';

var useCurrentBreakpointIndex = function useCurrentBreakpointIndex() {
  var _useState = useState(0),
      breakpointIndex = _useState[0],
      setBreakpointIndex = _useState[1];

  var theme = useTheme();
  var breakpointValue = useBreakpointValue(theme.breakpoints);
  useLayoutEffect(function () {
    var breakpointValueIndex = theme.breakpoints.indexOf(breakpointValue);
    setBreakpointIndex(breakpointValueIndex);
  }, [breakpointValue]);
  return breakpointIndex;
};

export default useCurrentBreakpointIndex;